import {
  faAnchor,
  faFire,
  faPeopleArrows,
  faTruck,
  faUserFriends,
  faUserMinus,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import ArrivalsOfShipsShiftDirector from "../../shiftDirector/ArrivalOfShips";
import CrewDescentsShiftDirector from "../../shiftDirector/CrewDescents";
import CrewEntriesShiftDirector from "../../shiftDirector/CrewEntries";
import FireReportShiftDirector from "../../shiftDirector/FireReport";
import NotificationInPortsShiftDirector from "../../shiftDirector/NotificationsInPorts";
import ServicesAndDeliverieShiftDirector from "../../shiftDirector/ServicesAndDeliveries";
import SupportShiftDirector from "../../shiftDirector/Support";
import SupportReportShiftDirector from "../../shiftDirector/Support/SupportReport";

const useNavLinksArray = () => {
  const { t } = useTranslation();

  const navLinksArrayShiftDirector: navLinksArrayTimeWorkerInterface = {
    profileId: 9,
    ifIgonreSettingsPreferences: false,
    routesArrayWithComponents: [
      {
        icon: faTruck,
        name: t("services_and_deliveries"),
        ifHidden: false,
        singleLink: true,
        path: "/shift-director/home",
        component: () => <ServicesAndDeliverieShiftDirector />,
      },
      {
        icon: faUserPlus,
        name: t("crew_entry"),
        ifHidden: false,
        singleLink: true,
        path: "/shift-director/crew-entries",
        component: () => <CrewEntriesShiftDirector />,
      },
      {
        icon: faUserMinus,
        name: t("crew_descent"),
        ifHidden: false,
        singleLink: true,
        path: "/shift-director/crew-descents",
        component: () => <CrewDescentsShiftDirector />,
      },
      {
        icon: faAnchor,
        name: t("arrival_of_ships"),
        ifHidden: false,
        singleLink: true,
        path: "/shift-director/arrival-of-ships",
        component: () => <ArrivalsOfShipsShiftDirector />,
      },
      {
        icon: faPeopleArrows,
        name: t("support"),
        ifHidden: false,
        singleLink: false,
        path: [
          {
            name: t("support"),
            path: "/shift-director/support",
            ifHidden: false,
            component: () => <SupportShiftDirector />,
          },
          {
            name: t("support_report"),
            path: "/shift-director/support-report",
            ifHidden: false,
            component: () => <SupportReportShiftDirector />,
          },
        ],
      },
      {
        icon: faUserFriends,
        name: t("notifications"),
        ifHidden: false,
        singleLink: true,
        path: "/shift-director/notifications",
        component: () => <NotificationInPortsShiftDirector />,
      },
      {
        icon: faFire,
        name: t("fire_report"),
        ifHidden: false,
        singleLink: true,
        path: "/shift-director/fire-report",
        component: () => <FireReportShiftDirector />,
      },
    ],
  };

  return navLinksArrayShiftDirector;
};
export default useNavLinksArray;
